import { render } from "./TicketsMenu.vue?vue&type=template&id=6f441ea1&scoped=true"
import script from "./TicketsMenu.vue?vue&type=script&lang=js"
export * from "./TicketsMenu.vue?vue&type=script&lang=js"

import "./TicketsMenu.vue?vue&type=style&index=0&id=6f441ea1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f441ea1"]])

export default __exports__